import { FC } from 'react';

import Chip from '@mui/material/Chip/Chip';
import Stack from '@mui/material/Stack/Stack';
import Typography from '@mui/material/Typography/Typography';

import IconDisplay from '@/shared/components/utilities/IconDisplay';

type AddCashChipProps = {
  iconName: string;
  amount: number;
  fractionDigits: number;
  mode: 'addition' | 'subtraction';
  onAddFixedAmount: (value: number) => void;
};

const AddCashChip: FC<AddCashChipProps> = ({
  iconName,
  amount,
  fractionDigits,
  mode,
  onAddFixedAmount,
}) => {
  return (
    <Chip
      clickable
      onClick={() => onAddFixedAmount(amount)}
      label={
        <Stack direction='row' spacing={1} alignItems='center'>
          <IconDisplay
            iconName={iconName}
            sx={{ width: 20, height: 20, color: 'text.secondary' }}
          />
          <Typography variant='caption'>
            {mode === 'addition' ? '+' : '-'}
            {amount.toFixed(fractionDigits)}
          </Typography>
        </Stack>
      }
    />
  );
};

export default AddCashChip;
